var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwitchappIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.359,
    height: 44.358,
    viewBox: "0 0 44.359 44.358",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16999",
    "data-name": "Group 16999",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30898",
    "data-name": "Path 30898",
    d: "M689.906,437.21a22.179,22.179,0,0,1-28.546,33.95l15.021-15.021c-1.8.006-5.157.008-5.389-.059a.946.946,0,0,1-.626-.739v-.217a.964.964,0,0,1,.609-.724.842.842,0,0,1,.154-.018h8.82c.643,0,1.189.583.006,1.794-.118.122-.215.219-.333.341s-.246.218-.365.34l-.479.5,3.938,3.937,7.189-24.078Z",
    transform: "translate(-653.33 -431.901)",
    fill: "#05f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30899",
    "data-name": "Path 30899",
    d: "M22.18,0A22.085,22.085,0,0,1,36.329,5.1L21.308,20.121c1.8-.006,5.157-.008,5.39.059a.947.947,0,0,1,.626.739v.217a.965.965,0,0,1-.609.724.832.832,0,0,1-.155.018H17.74c-.643,0-1.19-.583-.007-1.793.119-.123.216-.219.334-.341s.246-.218.364-.34l.479-.5-3.937-3.937L7.783,39.05A22.178,22.178,0,0,1,22.18,0Z",
    fill: "#122270",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchappIcon);
export default __webpack_public_path__ + "static/media/switchapp-icon.b97fba62c5e52026aad019fbaa8c0352.svg";
export { ForwardRef as ReactComponent };